"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.COMPONENT_NAME = void 0;
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const next12_components_icon_n_1 = __importStar(require("@gcloud-npm/next12.components.icon-n"));
const next12_components_text_info_n_1 = __importStar(require("@gcloud-npm/next12.components.text-info-n"));
const FaqItem_1 = __importStar(require("./FaqItem"));
exports.COMPONENT_NAME = "Faqs";
const Faqs = ({ openAllQuestions, title, titleProps, listadoFAQS, faqItemOptions, variant, segment, className, }) => {
    const taggingInfo = {
        componentName: exports.COMPONENT_NAME,
        componentContent: "",
        componentProduct: "",
        componentVariation: "all",
    };
    if (!listadoFAQS) {
        return null;
    }
    return (react_1.default.createElement("section", { className: `${className} faqs faqs-m container` },
        title && (react_1.default.createElement(next12_components_text_info_n_1.default, Object.assign({ className: "faqs__title", kind: next12_components_text_info_n_1.TEXT_INFO_KIND.HEADING, level: next12_components_text_info_n_1.TEXT_INFO_HEADING_LEVEL.H2, align: next12_components_text_info_n_1.TEXT_INFO_ALIGN.CENTER, fontType: next12_components_text_info_n_1.TEXT_INFO_FONT_WEIGHT.LIGHT, size: next12_components_text_info_n_1.TEXT_INFO_SIZE.TITLE3, color: next12_components_text_info_n_1.TEXT_INFO_COLOR.BLUE, text: title }, titleProps))),
        listadoFAQS && Array.isArray(listadoFAQS) && listadoFAQS.length > 0 && (react_1.default.createElement("ul", { className: "faqs__content" }, listadoFAQS.map((eachQuestion, index) => (react_1.default.createElement(FaqItem_1.default, { key: `faq-${eachQuestion.title}`, isOpen: openAllQuestions, faqTitle: eachQuestion.title, faqContent: eachQuestion.description || eachQuestion.content, taggingInfo: taggingInfo, options: faqItemOptions, variant: variant, Icon: next12_components_icon_n_1.default, segment: segment, index: index })))))));
};
Faqs.propTypes = {
    /**
     * {
     * "info": "Booleano que nos permite abrir todas las preguntas por defecto",
     * "kind": "both",
     * "beautifulName": "",
     * "injectComponent": ""
     * }
     */
    openAllQuestions: prop_types_1.default.bool,
    /**
     * {
     * "info": "Titulo que aparece para la lista de las preguntas frecuentes/faqs",
     * "kind": "both",
     * "beautifulName": "",
     * "injectComponent": ""
     * }
     */
    title: prop_types_1.default.string,
    /**
     * {
     * "info": "Opciones para cambiar el titulo de cada pregunta frecuente/faq",
     * "kind": "both",
     * "beautifulName": "",
     * "injectComponent": ""
     * }
     */
    titleProps: prop_types_1.default.object,
    /**
     * {
     * "info": "Listado de preguntas frecuentes/faqs",
     * "kind": "both",
     * "beautifulName": "",
     * "injectComponent": ""
     * }
     */
    listadoFAQS: prop_types_1.default.arrayOf(prop_types_1.default.shape({
        title: prop_types_1.default.string.isRequired,
        description: prop_types_1.default.string.isRequired,
    }).isRequired).isRequired,
    /**
     * {
     * "info": "Opciones para cambiar los colores de cada pregunta frecuente/faq",
     * "kind": "both",
     * "beautifulName": "",
     * "injectComponent": ""
     * }
     */
    faqItemOptions: prop_types_1.default.shape({
        /**
         * {
         * "info": "Cuando la pregunta frecuente/faq está sin abrir",
         * "kind": "both",
         * "beautifulName": "",
         * "injectComponent": ""
         * }
         */
        default: prop_types_1.default.shape({
            color: prop_types_1.default.shape({
                title: prop_types_1.default.oneOf(Object.values(next12_components_text_info_n_1.TEXT_INFO_COLOR)),
                icon: prop_types_1.default.oneOf(Object.values(next12_components_icon_n_1.ICON_COLOR)),
            }),
        }),
        /**
         * {
         * "info": "Cuando la pregunta frecuente/faq está abierta",
         * "kind": "both",
         * "beautifulName": "",
         * "injectComponent": ""
         * }
         */
        activated: prop_types_1.default.shape({
            color: prop_types_1.default.shape({
                title: prop_types_1.default.oneOf(Object.values(next12_components_text_info_n_1.TEXT_INFO_COLOR)),
                icon: prop_types_1.default.oneOf(Object.values(next12_components_icon_n_1.ICON_COLOR)),
            }),
        }),
    }),
    /**
     * {
     * "info": "Dependiendo del tipo de "variant" se cambian los estilos de cada pregunta frecuente/faq. Es un modificador",
     * "kind": "both",
     * "beautifulName": "",
     * "injectComponent": ""
     * }
     */
    variant: prop_types_1.default.oneOf(Object.values(FaqItem_1.VARIANT)),
    /**
     * {
     *  "info": "Necesita para especificar el segmento",
     *  "kind": "both",
     *  "beautifulName": "Segmento"
     * }
     */
    segment: prop_types_1.default.oneOf(Object.values(next12_components_text_info_n_1.TEXT_INFO_SEGMENT)),
    className: prop_types_1.default.string,
};
Faqs.defaultProps = {
    openAllQuestions: false,
    title: "",
    titleProps: {},
    faqItemOptions: {
        default: {
            color: {
                title: next12_components_text_info_n_1.TEXT_INFO_COLOR.GREY_5,
                icon: next12_components_icon_n_1.ICON_COLOR.BLUE,
            },
        },
        activated: {
            color: {
                title: next12_components_text_info_n_1.TEXT_INFO_COLOR.GREY_6,
                icon: next12_components_icon_n_1.ICON_COLOR.BLUE,
            },
        },
    },
    variant: FaqItem_1.VARIANT.DEFAULT,
    segment: next12_components_text_info_n_1.TEXT_INFO_SEGMENT.GP,
    className: "",
};
exports.default = Faqs;
//# sourceMappingURL=index.js.map